import "./App.css";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import animacaoJson from "./btck-loading.json";
import animacaoJsonError from "./erro-back.json";
import { asaasGeneratePaymentSlip } from "./services/asaas/asaasGeneratePaymentSlip";
// PIX: fachada Mercado Pago (Asaas desativado por flag, código mantido).
import {
  generatePixPayment,
  getPixPaymentInfos,
  verifyPixPayment,
  isPixPaidStatus,
} from "./services/pix/pixPayment";

function App() {
  const [dataPayment, setDataPayment] = useState(null);
  const [requestSuccess, setRequestSuccess] = useState(null);
  const [savePayment, setSavePayment] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const path = window.location.pathname;
  const quote = path.split("/")[1];
  const complement = path.split("/")[2];

  const params = new URLSearchParams(window.location.search);
  const typePayment = params.get("type");

  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [pixPaymentInfos, setPixPaymentInfos] = useState(null);
  const [paymentSlipInfos, setPaymentSlipInfos] = useState(null);
  const [pixCopied, setPixCopied] = useState(false);
  const [cpfValue, setCpfValue] = useState("");
  const [cpfError, setCpfError] = useState("");

  let uuidOrder;
  let type;

  if (complement === undefined || complement === "") {
    uuidOrder = quote;
    type = "quote";
  } else {
    uuidOrder = complement;
    type = "complement";
  }

  if (typePayment === "carWorkshop") {
    type = 'carWorkshop'
  }

  if (typePayment === "unlockFee") {
    type = 'unlockFee'
  }

  // Pagamentos de "taxa fixa" (não usam o total do orçamento): visualização das
  // oficinas (carWorkshop = R$99,90) e desbloqueio dos orçamentos (unlockFee = R$39,90).
  const isFeeOnly =
    typePayment === "carWorkshop" || typePayment === "unlockFee";
  const feeOnlyValue = typePayment === "unlockFee" ? 39.9 : 99.9;

  const handleAsaasPixPayment = async () => {
    setIsLoadingPayment(true);
    const generatePixPaymentResponse = await generatePixPayment({
      asaasCustomerId: dataPayment?.customer?.asaasCustomerId,
      value: isFeeOnly ? feeOnlyValue : dataPayment?.canUserSeeCarWorkshops ? dataPayment.totalToPay : dataPayment?.totalToPay,
      description: dataPayment?.ref,
      payerEmail: dataPayment?.customer?.email,
      payerCpf: dataPayment?.customer?.document,
      payerName: [dataPayment?.customer?.name, dataPayment?.customer?.surname].filter(Boolean).join(" "),
    });

    if (!generatePixPaymentResponse?.success) {
      setRequestSuccess(false);
      setIsLoadingPayment(false);
      return;
    }

    const paymentInfos = await getPixPaymentInfos({
      paymentId: generatePixPaymentResponse?.paymentId,
      type: "pixQrCode",
    });

    if (!paymentInfos?.success) {
      setRequestSuccess(false);
      setIsLoadingPayment(false);
      return;
    }

    setPixPaymentInfos({
      paymentId: generatePixPaymentResponse?.paymentId,
      image: paymentInfos?.paymentImage,
      payload: paymentInfos?.paymentPayload,
    });

    setIsLoadingPayment(false);
  };

  const handleAsaasPaymentSlip = async () => {
    setIsLoadingPayment(true);

    const generatePaymentSlip = await asaasGeneratePaymentSlip({
      asaasCustomerId: dataPayment?.customer?.asaasCustomerId,
      value: isFeeOnly ? feeOnlyValue : dataPayment?.canUserSeeCarWorkshops ? dataPayment.totalToPay : dataPayment?.totalToPay,
      description: dataPayment?.ref,
      type: type,
      uuid: uuidOrder,
    });

    if (!generatePaymentSlip?.success) {
      setRequestSuccess(false);
      setIsLoadingPayment(false);
      return;
    }

    setPaymentSlipInfos({
      paymentId: generatePaymentSlip?.paymentId,
      bankSlipUrl: generatePaymentSlip?.bankSlipUrl,
    });

    window.open(generatePaymentSlip?.bankSlipUrl, "_blank");

    setIsLoadingPayment(false);
  };

  const handleCopyPixCode = ({ link }) => {
    // Fallback para dispositivos móveis e contextos inseguros
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(link)
        .then(() => {
          setPixCopied(true);
          setTimeout(() => {
            setPixCopied(false);
          }, 2000);
        })
        .catch(() => {
          // Se falhar, usa o método de fallback
          fallbackCopyTextToClipboard(link);
        });
    } else {
      // Método de fallback para dispositivos que não suportam clipboard API
      fallbackCopyTextToClipboard(link);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Evita scroll para o elemento
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      setPixCopied(true);
      setTimeout(() => {
        setPixCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Erro ao copiar texto: ', err);
    }
    
    document.body.removeChild(textArea);
  };

  const formatCpf = (value) => {
    if (!value) return "";

    const digits = value.replace(/\D/g, "").slice(0, 11);
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 9);
    const part4 = digits.slice(9, 11);

    let formatted = part1;
    if (part2) formatted += `.${part2}`;
    if (part3) formatted += `.${part3}`;
    if (part4) formatted += `-${part4}`;

    return formatted;
  };

  const handleCpfChange = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, "");
    setCpfValue(digitsOnly.slice(0, 11));
    if (cpfError) setCpfError("");
  };

  const handleSubmitCpf = async () => {
    if (!cpfValue.trim()) {
      setCpfError("Por favor, informe seu CPF.");
      return;
    }

    if (!dataPayment?.customer?.uuid) {
      setCpfError("Não foi possível identificar o cliente. Recarregue a página.");
      return;
    }

    try {
      const response = await axios.post(
        "/webapp/update-cpf",
        {
          webappCustomerUuid: dataPayment?.customer?.uuid,
          cpf: cpfValue,
        },
        {
          headers: {
            "ngrok-skip-browser-warning": "true",
            "Content-Type": "application/json",
            jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
          },
        }
      );

      if (!response?.data?.success) {
        throw new Error(response?.data?.message || "Erro ao atualizar CPF");
      }

      setDataPayment((prev) => {
        if (!prev) return prev;

        return {
          ...prev,
          customer: {
            ...prev.customer,
            document: cpfValue,
          },
        };
      });

      setCpfError("");
    } catch (error) {
      setCpfError(
        error?.response?.data?.message ||
          error?.message ||
          "Erro ao atualizar CPF. Tente novamente."
      );
    }
  };

  const handlePaymentStatus = async () => {
    if (selectedPaymentMethod !== "pix") return;

    const response = await verifyPixPayment({
      paymentId: pixPaymentInfos?.paymentId,
    });

    // Asaas = RECEIVED, Mercado Pago = approved
    if (isPixPaidStatus(response?.status)) {

      setProcessing(true);
      axios
        .post(
          `/webapp/approve/payment/${uuidOrder}?type=${type}`,
          {
            orderID: "",
            payerID: dataPayment?.customer?.asaasCustomerId,
            paymentID: pixPaymentInfos?.paymentId,
            facilitatorAccessToken: "",
            paymentSource: "pix",
          },
          {
            headers: {
              "ngrok-skip-browser-warning": "true",
              "Content-Type": "application/json",
              jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
            },
          }
        )
        .then((response) => {
          window.parent.postMessage({ success: true, data: "payment" }, "*");
        })
        .catch((error) => {
          setSavePayment(false);
          console.error(error);
        });
    }
  };

  useEffect(() => {
    if (!pixPaymentInfos?.paymentId) return;

    handlePaymentStatus();

    const interval = setInterval(() => {
      handlePaymentStatus();
    }, 10000);

    return () => clearInterval(interval);
  }, [pixPaymentInfos?.paymentId]);

  useEffect(() => {
    if (!dataPayment) return;

    if (selectedPaymentMethod === "pix" && !pixPaymentInfos) {
      handleAsaasPixPayment();
    }

    if (selectedPaymentMethod === "paymentSlip" && !paymentSlipInfos) {
      handleAsaasPaymentSlip();
    }

    if (selectedPaymentMethod === "paymentSlip" && paymentSlipInfos) {
      window.open(paymentSlipInfos?.bankSlipUrl, "_blank");
    }
  }, [selectedPaymentMethod, dataPayment]);

  useEffect(() => {
    axios
      .get(`/webapp/infos/${uuidOrder}?type=${(type === 'carWorkshop' || type === 'unlockFee') ? 'quote' : type}`, {
        headers: {
          "ngrok-skip-browser-warning": "true",
          "Content-Type": "application/json",
          jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
        },
      })
      .then((response) => {
        setDataPayment(response.data.infos);
      })
      .catch((error) => {
        setRequestSuccess(false);
      });
  }, []);

  if (!dataPayment?.customer?.document) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          gap: "20px",
          textAlign: "center",
        }}
      >
        <div>
          <h2 style={{ marginBottom: "10px" }}>Informe seu CPF</h2>
          <p style={{ margin: 0, color: "#666", fontSize: "14px" }}>
            Precisamos do seu CPF para continuar o processo de pagamento.
          </p>
        </div>

        <input
          type="text"
          value={formatCpf(cpfValue)}
          onChange={handleCpfChange}
          placeholder="Digite seu CPF"
          style={{
            boxSizing: "border-box",
            width: "100%",
            maxWidth: "600px",
            padding: "12px 16px",
            fontSize: "16px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            outline: "none",
          }}
        />

        <button
          onClick={handleSubmitCpf}
          style={{
            width: "100%",
            maxWidth: "600px",
            padding: "12px 16px",
            fontSize: "16px",
            backgroundColor: "#32BBAD",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Enviar
        </button>
        {cpfError && (
          <p style={{ color: "red", fontSize: "14px", margin: 0 }}>{cpfError}</p>
        )}
      </div>
    );
  }

  // Render payment method selection screen if no method is selected yet
  if (selectedPaymentMethod === null) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Selecione a forma de pagamento</h2>
        {typePayment === "carWorkshop" && uuidOrder === "2430d191-b3da-4ff2-8634-88fb0fccd024" && (
          <>
            <h4>Pague, e veja as informações das oficinas</h4>
            <button
              onClick={() => {
                axios
                  .post(
                    `/webapp/approve/payment/${uuidOrder}?type=${type}`,
                    { dev: 'dev' },
                    {
                      headers: {
                        "ngrok-skip-browser-warning": "true",
                        "Content-Type": "application/json",
                        jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
                      },
                    }
                  ).then((response) => {
                    window.parent.postMessage(
                      { success: true, data: "payment" },
                      "*"
                    );
                  })
              }}
              style={{
                padding: "15px",
                fontSize: "16px",
                backgroundColor: "#32BBAD",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <span>###</span>
              <span>TESTAR PAGAMENTO</span>
              <span>###</span>
            </button>
          </>
        )}
        {uuidOrder === "2430d191-b3da-4ff2-8634-88fb0fccd024" && (
          <>
            <h4>Pague, e realize o agendamento</h4>
            <button
              onClick={() => {
                axios
                  .post(
                    `/webapp/approve/payment/${uuidOrder}?type=${type}`,
                    { "orderID": "7MB60537YE632835C", "payerID": "6DFH74JKT84RE", "paymentID": "7MB60537YE632835C", "billingToken": null, "facilitatorAccessToken": "A21AAMvsB90g43nnDTGU7pwdU8ccsO-1A8cYutq_WMBRGIgfHufv6h29mZdmAMJqm7T6La5KVW9HevFDy2RaAULtP-LSNndVA", "paymentSource": "card" },
                    {
                      headers: {
                        "ngrok-skip-browser-warning": "true",
                        "Content-Type": "application/json",
                        jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
                      },
                    }
                  ).then((response) => {
                    window.parent.postMessage(
                      { success: true, data: "payment" },
                      "*"
                    );
                  })
              }}
              style={{
                padding: "15px",
                fontSize: "16px",
                backgroundColor: "#32BBAD",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <span>###</span>
              <span>TESTAR PAGAMENTO ORCAMENTO</span>
              <span>###</span>
            </button>
          </>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            marginTop: "30px",
          }}
        >
          <button
            onClick={() => setSelectedPaymentMethod("pix")}
            style={{
              padding: "12px 20px",
              fontSize: "16px",
              backgroundColor: "#32BBAD",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <span>Pagar com Pix</span>
            <div
              style={{
                backgroundColor: "#ffffff",
                padding: "4px 8px",
                borderRadius: "6px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
              }}
            >
              <img
                src="/mercadopago.png"
                alt="Mercado Pago"
                style={{ height: "30px", width: "auto", objectFit: "contain" }}
              />
            </div>
          </button>
          <button
            onClick={() => setSelectedPaymentMethod("credit_card")}
            style={{
              padding: "12px 20px",
              fontSize: "16px",
              backgroundColor: "#003087",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <span>Pagar com Cartão de Crédito</span>
            <span style={{ fontSize: "14px", opacity: 0.95 }}>(12x SEM JUROS)</span>
            <div
              style={{
                backgroundColor: "#ffffff",
                padding: "4px 8px",
                borderRadius: "6px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
              }}
            >
              <img
                src="/visa-mastercard.png"
                alt="Visa e Mastercard"
                style={{ height: "24px", width: "auto", objectFit: "contain" }}
              />
            </div>
          </button>
          <button
            onClick={() => setSelectedPaymentMethod("paymentSlip")}
            style={{
              padding: "12px 20px",
              fontSize: "16px",
              backgroundColor: "#19769A",
              color: "white",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <span>Pagar com Boleto</span>
            <div
              style={{
                backgroundColor: "#ffffff",
                padding: "4px 8px",
                borderRadius: "6px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
              }}
            >
              <img
                src="/asaas.png"
                alt="Asaas"
                style={{ height: "24px", width: "auto", objectFit: "contain" }}
              />
            </div>
          </button>
        </div>
      </div>
    );
  }

  // Render Pix payment screen
  if (selectedPaymentMethod === "pix") {
    return (
      <>
        <div style={{ padding: "20px" }}></div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginLeft: "20px",
          }}
          onClick={() => setSelectedPaymentMethod(null)}
        >
          <img src="/back.png" alt="" width={40} />
        </div>

        <div style={{ padding: "15px" }}>
          {dataPayment?.totalParts && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Peças:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(isFeeOnly ? 0 : dataPayment.totalParts)}
              </p>
            </div>
          )}

          {dataPayment?.totalServices && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Serviços:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(isFeeOnly ? 0 : dataPayment.totalServices)}
              </p>
            </div>
          )}

          {typePayment === "carWorkshop" && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Visualização das oficinas:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(99.9)}
              </p>
            </div>
          )}
          {typePayment === "unlockFee" && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Desbloqueio de todos os orçamentos:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(39.9)}
              </p>
            </div>
          )}

          {/* {type === "quote" && dataPayment?.canUserSeeCarWorkshops === true && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Visualização das oficinas:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                - {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(99.9)}
              </p>
            </div>
          )} */}

          {!isFeeOnly && dataPayment?.taxaDiscountPercent && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ textAlign: "left", margin: "5px" }}>Total sem desconto:</p>
                <p style={{ textAlign: "right", margin: "5px", textDecoration: "line-through", color: "#999" }}>
                  {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(dataPayment.totalToPayWithoutDiscount)}
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ textAlign: "left", margin: "5px" }}>Desconto Taxa BateClick ({dataPayment.taxaDiscountPercent}%):</p>
                <p style={{ textAlign: "right", margin: "5px", color: "#28a745", fontWeight: "bold" }}>
                  - {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(dataPayment.totalToPayWithoutDiscount) - Number(dataPayment.totalToPay))}
                </p>
              </div>
            </>
          )}
          {!isFeeOnly && Number(dataPayment?.unlockFeesTotal) > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>
                Taxa de desbloqueio dos orçamentos:
              </p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(dataPayment.unlockFeesTotal))}
              </p>
            </div>
          )}
          {dataPayment?.totalToPay && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              <p style={{ textAlign: "left", margin: "5px" }}>{dataPayment?.taxaDiscountPercent && typePayment !== "carWorkshop" ? "Total com desconto:" : "Subtotal:"}</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(isFeeOnly ? feeOnlyValue : dataPayment.totalToPay)}
              </p>
            </div>
          )}
        </div>
        <div style={{ padding: "20px", textAlign: "center" }}>
          {isLoadingPayment ? (
            <p>Carregando ...</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
                padding: "10px"
              }}
            >
              <div
                style={{
                  width: "100%",
                  padding: "1rem",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  marginBottom: "1rem",
                }}
              >
                <p style={{ 
                  margin: 0,
                  fontSize: "12px", 
                  wordBreak: "break-all",
                  textAlign: "center",
                  color: "#333"
                }}>
                  {pixPaymentInfos?.payload}
                </p>
              </div>
              
              <button
                onClick={() =>
                  handleCopyPixCode({
                    link: pixPaymentInfos?.payload,
                  })
                }
                style={{
                  padding: "12px 24px",
                  fontSize: "14px",
                  backgroundColor: pixCopied ? "#28a745" : "#007bff",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "background-color 0.3s ease",
                  marginBottom: "1rem"
                }}
              >
                {pixCopied ? "✓ Copiado com sucesso!" : "Copiar Chave PIX"}
              </button>
              
              <p style={{ margin: "0 0 1rem 0", fontSize: "14px", color: "#666" }}>ou</p>
              
              <img
                src={`data:image/png;base64,${pixPaymentInfos?.image}`}
                width={200}
                alt="Pix QRCode"
              />
            </div>
          )}
        </div>
      </>
    );
  }

  // Render Boleto payment screen
  if (selectedPaymentMethod === "paymentSlip") {
    return (
      <>
        <div style={{ padding: "20px" }}></div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginLeft: "20px",
          }}
          onClick={() => setSelectedPaymentMethod(null)}
        >
          <img src="/back.png" alt="" width={40} />
        </div>

        <div style={{ padding: "15px" }}>
          {dataPayment?.totalParts && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Peças:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(isFeeOnly ? 0 : dataPayment.totalParts)}
              </p>
            </div>
          )}

          {dataPayment?.totalServices && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Serviços:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(isFeeOnly ? 0 : dataPayment.totalServices)}
              </p>
            </div>
          )}

          {typePayment === "carWorkshop" && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Visualização das oficinas:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(99.9)}
              </p>
            </div>
          )}
          {typePayment === "unlockFee" && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Desbloqueio de todos os orçamentos:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(39.9)}
              </p>
            </div>
          )}

          {/* {type === "quote" && dataPayment?.canUserSeeCarWorkshops === true && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Visualização das oficinas:</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                - {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(99.9)}
              </p>
            </div>
          )} */}

          {!isFeeOnly && dataPayment?.taxaDiscountPercent && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ textAlign: "left", margin: "5px" }}>Total sem desconto:</p>
                <p style={{ textAlign: "right", margin: "5px", textDecoration: "line-through", color: "#999" }}>
                  {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(dataPayment.totalToPayWithoutDiscount)}
                </p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ textAlign: "left", margin: "5px" }}>Desconto Taxa BateClick ({dataPayment.taxaDiscountPercent}%):</p>
                <p style={{ textAlign: "right", margin: "5px", color: "#28a745", fontWeight: "bold" }}>
                  - {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(dataPayment.totalToPayWithoutDiscount) - Number(dataPayment.totalToPay))}
                </p>
              </div>
            </>
          )}
          {!isFeeOnly && Number(dataPayment?.unlockFeesTotal) > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>
                Taxa de desbloqueio dos orçamentos:
              </p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(dataPayment.unlockFeesTotal))}
              </p>
            </div>
          )}
          {dataPayment?.totalToPay && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
              }}
            >
              <p style={{ textAlign: "left", margin: "5px" }}>{dataPayment?.taxaDiscountPercent && typePayment !== "carWorkshop" ? "Total com desconto:" : "Subtotal:"}</p>
              <p style={{ textAlign: "right", margin: "5px" }}>
                {new Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(isFeeOnly ? feeOnlyValue : dataPayment.totalToPay)}
              </p>
            </div>
          )}
        </div>
        <div style={{ padding: "20px", textAlign: "center" }}>
          {isLoadingPayment ? (
            <p>Carregando ...</p>
          ) : (
            <p>
              Após o pagamento, seu orçamento será atualizado em até 24 horas.
            </p>
          )}
        </div>
      </>
    );
  }

  // Render credit card payment flow
  return (
    <>
      <div style={{ padding: "20px" }}></div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          marginLeft: "20px",
        }}
        onClick={() => setSelectedPaymentMethod(null)}
      >
        <img src="/back.png" alt="" width={40} />
      </div>

      <div style={{ padding: "15px" }}>
        {dataPayment?.totalParts && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Peças:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(isFeeOnly ? 0 : dataPayment.totalParts)}
            </p>
          </div>
        )}

        {dataPayment?.totalServices && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Serviços:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(isFeeOnly ? 0 : dataPayment.totalServices)}
            </p>
          </div>
        )}

        {typePayment === "carWorkshop" && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Visualização das oficinas:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(99.9)}
            </p>
          </div>
        )}
        {typePayment === "unlockFee" && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Desbloqueio de todos os orçamentos:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(39.9)}
            </p>
          </div>
        )}

        {/* {type === "quote" && dataPayment?.canUserSeeCarWorkshops === true && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>Visualização das oficinas:</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              - {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(99.9)}
            </p>
          </div>
        )} */}

        {!isFeeOnly && dataPayment?.taxaDiscountPercent && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Total sem desconto:</p>
              <p style={{ textAlign: "right", margin: "5px", textDecoration: "line-through", color: "#999" }}>
                {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(dataPayment.totalToPayWithoutDiscount)}
              </p>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ textAlign: "left", margin: "5px" }}>Desconto Taxa BateClick ({dataPayment.taxaDiscountPercent}%):</p>
              <p style={{ textAlign: "right", margin: "5px", color: "#28a745", fontWeight: "bold" }}>
                - {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(dataPayment.totalToPayWithoutDiscount) - Number(dataPayment.totalToPay))}
              </p>
            </div>
          </>
        )}
        {!isFeeOnly && Number(dataPayment?.unlockFeesTotal) > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ textAlign: "left", margin: "5px" }}>
              Taxa de desbloqueio dos orçamentos:
            </p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(dataPayment.unlockFeesTotal))}
            </p>
          </div>
        )}
        {dataPayment?.totalToPay && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "bold",
            }}
          >
            <p style={{ textAlign: "left", margin: "5px" }}>{dataPayment?.taxaDiscountPercent && typePayment !== "carWorkshop" ? "Total com desconto:" : "Subtotal:"}</p>
            <p style={{ textAlign: "right", margin: "5px" }}>
              {new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(isFeeOnly ? feeOnlyValue : dataPayment.totalToPay)}
            </p>
          </div>
        )}
      </div>
      <PayPalScriptProvider
        options={{
          "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
          currency: "BRL",
        }}
      >
        {/* <p>Pague de forma 100% segura</p> */}

        {!dataPayment && requestSuccess === null && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p>Carregando...</p>
              <Lottie animationData={animacaoJson} loop={true} />
            </div>
          </div>
        )}

        {requestSuccess === false && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p style={{ color: "red" }}>
                Erro ao processar pagamento no momento, por favor tente
                novamente ou mais tarde
              </p>
            </div>
          </div>
        )}

        {!savePayment && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p style={{ color: "yellow" }}>
                O pagamento foi autorizado, mas não conseguimos salvar a
                informação no momento, por favor entre em contato via WhatsApp
              </p>
              <Lottie animationData={animacaoJsonError} loop={true} />
            </div>
          </div>
        )}

        {processing && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "80%",
              }}
            >
              <p style={{ color: "yellow" }}>
                Estamos processando seu pagamento...
              </p>
              <Lottie animationData={animacaoJson} loop={true} />
            </div>
          </div>
        )}

        {dataPayment && savePayment === true && !processing && (
          <div
            style={{
              backgroundColor: "#bcc6be",
              padding: "15px",
              borderRadius: "25px",
              width: "85%",
              margin: "0 auto",
            }}
          >
            <PayPalButtons
              fundingSource="card"
              style={{
                layout: "vertical",
                color: "black",
                shape: "rect",
                fundingicons: true,
                tagline: false,
              }}
              createOrder={(data, actions) => {
                return actions.order.create({
                  purchase_units: [
                    {
                      amount: {
                        value: isFeeOnly ? feeOnlyValue : dataPayment?.canUserSeeCarWorkshops ? dataPayment.totalToPay : dataPayment.totalToPay,
                      },
                      custom_id: uuidOrder,
                      invoice_id: dataPayment.ref,
                    },
                  ],
                  payer: {
                    name: {
                      given_name: dataPayment.customer.name,
                      surname: dataPayment.customer?.surname || "",
                    },
                    email_address: dataPayment.customer.email,
                    phone: {
                      phone_number: {
                        national_number: dataPayment.customer.mobilePhone,
                      },
                    },
                    tax_info: {
                      tax_id_type: "BR_CPF",
                      tax_id: dataPayment.customer.document,
                    },
                    address: {
                      address_line_1: dataPayment.address.street,
                      admin_area_2: dataPayment.address.city,
                      postal_code: dataPayment.address.cep,
                      country_code: "BR",
                    },
                  },
                  application_context: {
                    shipping_preference: "NO_SHIPPING",
                  },
                });
              }}
              onApprove={(data, actions) => {
                return actions.order.capture().then((details) => {
                  setProcessing(true);
                  axios
                    .post(
                      `/webapp/approve/payment/${uuidOrder}?type=${type}`,
                      data,
                      {
                        headers: {
                          "ngrok-skip-browser-warning": "true",
                          "Content-Type": "application/json",
                          jwt: process.env.REACT_APP_DEFAULT_WEBAPP_BACKEND_JWT,
                        },
                      }
                    )
                    .then((response) => {
                      window.parent.postMessage(
                        { success: true, data: "payment" },
                        "*"
                      );
                    })
                    .catch((error) => {
                      setSavePayment(false);
                      console.error(error);
                    });
                });
              }}
              onError={(err) => {
                console.error(err);
                alert("Ocorreu um erro no processamento do pagamento");
              }}
            />
          </div>
        )}
      </PayPalScriptProvider>
      {dataPayment && savePayment === true && type !== "carWorkshop" && (
        <div
          style={{
            width: "100%",
            height: "5em",
            textAlign: "center",
            marginTop: "2em",
            marginBottom: "5em",
          }}
        >
          <img src="/timeline.png" height="100%" />
        </div>
      )}
      <div style={{ padding: "30px" }}></div>
    </>
  );
}

export default App;
